import { InputProps } from "antd"
import InputMask from "@mona-health/react-input-mask"
import React from "react"

import { languages } from "../../../../lib/languages"
import { formatNirFromMask } from "../../../../lib/utils"
import styles from "./NirInput.module.scss"

export interface NirInputProps
  extends Omit<InputProps, "onClick" | "onChange"> {
  onClick?: (nir: string) => void
  onChange?: (nir: string) => void
}
const NIR_MASK = `${languages.nirAllowedChar}${languages.nirSpacer}${languages.nirAllowedChar} ${languages.nirAllowedChar}${languages.nirSpacer}${languages.nirAllowedChar} ${languages.nirAllowedChar}${languages.nirSpacer}${languages.nirAllowedChar} ${languages.nirAllowedChar}${languages.nirSpacer}${languages.nirAllowedChar} ${languages.nirAllowedChar} ${languages.nirAllowedChar}${languages.nirSpacer}${languages.nirAllowedChar} ${languages.nirAllowedChar} ${languages.nirAllowedChar}${languages.nirSpacer}${languages.nirAllowedChar} ${languages.nirAllowedChar}`

const NirInput: React.FC<NirInputProps> = (props) => {
  const onChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const nir: string = formatNirFromMask(e.target.value)
    nir.length === 15 && e.target.blur()
    props.onChange && props.onChange(nir)
  }
  return (
    <InputMask
      readOnly={props.readOnly}
      disabled={props.disabled}
      id={props.name}
      name={props.name}
      onChange={onChange}
      value={props.value as string}
      alwaysShowMask
      className={styles.NirInput}
      mask={NIR_MASK}
    />
  )
}

export default NirInput
